import React from "react";
import styled from "styled-components";

const StyledPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[2]};
`;

interface IPanelHeaderProps {
  children: React.ReactNode;
  link?: React.ReactNode;
}

const StatusPanelHeader: React.FC<IPanelHeaderProps> = ({ children, link }) => (
  <StyledPanelHeader>
    {children}
    {link}
  </StyledPanelHeader>
);

interface IPanelBodyProps {
  children: React.ReactNode;
}

const StatusPanelBody: React.FC<IPanelBodyProps> = ({ children }) => (
  <div>{children}</div>
);

interface IPanelProps {
  children?: React.ReactNode;
}

const StatusPanel = ({ children }: IPanelProps) => {
  return <div>{children}</div>;
};

StatusPanel.Header = StatusPanelHeader;
StatusPanel.Body = StatusPanelBody;

export default StatusPanel;
